import { Building2, HardHat } from "lucide-react";
import { EmployerForm } from "./EmployerForm";
import { WorkerForm } from "./WorkerForm";

const TABS = [
  { id: "employer", label: "I'm an Employer", sub: "Post a workforce requirement", Icon: Building2 },
  { id: "worker", label: "I'm an Employee / Guard", sub: "Register for jobs", Icon: HardHat },
];

export const LeadForms = ({ tab, setTab, prefill, onContext }) => (
  <section id="register" className="relative scroll-mt-20 border-t border-white/5 bg-[#0B1120] py-20 lg:py-28">
    <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-4">
        <p className="eyebrow">Get started</p>
        <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-white lg:text-3xl">
          One form. Every district in India.
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-slate-400">
          Employers post headcount, shift and pay terms. Employees and security personnel register once and get matched to verified sites in their preferred area.
        </p>
        <div className="mt-6 flex flex-col gap-2.5">
          {TABS.map(({ id, label, sub, Icon }) => (
            <button key={id} type="button" onClick={() => setTab(id)} data-testid={`form-tab-${id}`}
              className={`flex items-center gap-3 rounded-xl border px-4 py-3 text-left transition-colors ${tab === id ? "border-orange-500 bg-orange-500/10" : "border-white/10 bg-[#0F172A] hover:border-orange-400"}`}>
              <Icon className={`h-6 w-6 ${tab === id ? "text-orange-400" : "text-slate-500"}`} />
              <span>
                <span className="block font-semibold text-white">{label}</span>
                <span className="block text-sm text-slate-400">{sub}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
      <div className="rounded-2xl border border-white/10 bg-[#1E293B]/60 p-5 backdrop-blur-xl sm:p-6 lg:col-span-8">
        <div className={tab === "employer" ? "" : "hidden"}><EmployerForm prefill={prefill?.tab === "employer" ? prefill : null} active={tab === "employer"} onContext={onContext} /></div>
        <div className={tab === "worker" ? "" : "hidden"}><WorkerForm prefill={prefill?.tab === "worker" ? prefill : null} active={tab === "worker"} onContext={onContext} /></div>
      </div>
    </div>
  </section>
);
